import React from "react";
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
export class ErrorBoundary extends React.Component {
    constructor(props) { super(props); this.state = { error: null, showFallback: false }; }
    componentDidCatch(error, info) { this.setState({ error, showFallback: true }); }
    render() { if (this.state.showFallback && this.state.error) {
        return /*#__PURE__*/ _jsx(_Fragment, { children: this.props.fallback(this.state.error, () => { this.setState({ error: null, showFallback: false }); }) });
    } return /*#__PURE__*/ _jsx(_Fragment, { children: this.props.children }); }
}
